import { Group, Popover, Text, UnstyledButton } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

interface Props {
  text: string;
  hoverText: string;
  size?: string;
}

export default ({ hoverText, size = 'sm', text }: Props) => {
  const { t } = useTranslation();
  const [opened, { close, open }] = useDisclosure(false);

  return (
    <section>
      <Group gap={10}>
        <Text size={size} c="gray.5">
          {text}
        </Text>
      </Group>
    </section>
  );
};
